import { Text, PopOverMenu } from "components/commons";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { dateFormat, formatAmount, timeFormat } from "utils";
import styles from "./shift-records.module.scss";
import { locale } from "localization/en";
import { FormMode, Path, ShiftStatus } from "enums";
import classNames from "classnames";

export const isProductExistInUGT = (productCode, stationUgt = []) => {
  return stationUgt.some((ugt) => ugt.productCode === productCode);
};

export const mapDataToList = ({ shifts, history }) => {
  const {
    startShift,
    endShift,
    shiftNumber,
    status,
    employees,
    totalBosTransactionCount,
    shiftId,
    totalTransactionCount,
    totalManualTransactionCount,
    totalSales,
    totalAdjustments,
    station,
  } = shifts;

  const sales = totalSales + totalAdjustments;
  const totalCount = totalTransactionCount + (totalManualTransactionCount ?? 0);
  const transactionCount = totalBosTransactionCount + (totalManualTransactionCount ?? 0) || 0;
  let syncPercentage = calculateSyncProgress({
    totalBosTransactionCount: transactionCount,
    totalTransactionCount: totalCount,
  });

  let syncStatus = "pending";
  if (syncPercentage === 100) {
    syncStatus = "done";
  } else if (syncPercentage > 100 && syncPercentage < 0) {
    syncStatus = "ongoing";
  }

  let cashier = "--";
  if (employees && employees.length > 0) {
    const copyEmployee = [...employees];
    copyEmployee.sort((a, b) => {
      return b.shiftEmployeeId - a.shiftEmployeeId;
    });
    cashier = copyEmployee[employees.length - 1].name;
  }

  const options = [
    {
      content: locale.viewDetails,
      onClick: () => {
        history.push(Path.viewShiftRecordDetailsUrl(shiftId, FormMode.View));
      },
    },
  ];

  return {
    stationCode: (
      <>
        <Text className={styles.td}>{station?.stationCode ?? "--"}</Text>
      </>
    ),
    stationName: (
      <>
        <Text className={styles.td}>{station?.name ?? "--"}</Text>
      </>
    ),
    startShift: (
      <>
        <Text className={styles.td}>{dateFormat(startShift ?? "")}</Text>
        <Text className={styles.td}>{timeFormat(startShift ?? "")}</Text>
      </>
    ),
    endShift: (
      <>
        <Text className={styles.td}>{endShift != null ? dateFormat(endShift) : "--"}</Text>
        <Text className={styles.td}>{endShift != null ? timeFormat(endShift) : ""}</Text>
      </>
    ),
    shiftNumber: (
      <>
        <Text className={styles.td}>
          {status === ShiftStatus.Started ? locale.currentShift : (shiftNumber ?? "--")}
        </Text>
      </>
    ),
    cashier: (
      <>
        <Text className={styles.td}>{cashier}</Text>
      </>
    ),
    totalSales: (
      <>
        <Text className={styles.td}>{formatAmount(sales ?? 0)}</Text>
      </>
    ),
    syncProgress: (
      <div className={styles.sync}>
        <Text className={classNames(styles.percentage, styles[syncStatus])}>
          {status !== ShiftStatus.Started && `${syncPercentage} %`}
          {status === ShiftStatus.Started ? (
            <span className={styles.content}>{`(${transactionCount})`}</span>
          ) : (
            <span className={styles.content}>{`(${transactionCount}/${totalCount})`}</span>
          )}
        </Text>
      </div>
    ),
    actions: (
      <>
        <PopOverMenu options={options}>
          <MoreVertIcon className={styles.icon} />
        </PopOverMenu>
      </>
    ),
  };
};

export const mapFilterToRequest = (filterState) => {
  const { statuses, cashiers, searchType, ...fs } = filterState;
  let newCashiers;
  if (cashiers.value.length && !cashiers.isAll) {
    newCashiers = cashiers.value
      .map(({ value }) => {
        return value;
      })
      .join(",");
  } else {
    newCashiers = null;
  }

  return {
    ...fs,
    searchType: searchType || "stationCode",
    cashiers: newCashiers,
    // statuses: !statuses.isSelectedAll ? statuses.value.join(",") : null,
  };
};

export const calculateSyncProgress = ({
  totalTransactionCount = 0,
  totalBosTransactionCount = 0,
}) => {
  if (Number(totalTransactionCount) === 0 && Number(totalBosTransactionCount) === 0) {
    return 100;
  }

  const syncPercentage =
    totalTransactionCount > 0 ? (totalBosTransactionCount / totalTransactionCount) * 100 : 0;

  return Math.round(syncPercentage * 100) / 100;
};
